import React from "react";
import { IoPlay } from "react-icons/io5";
import Image from "react-image-webp";
import { isWebpSupported } from "react-image-webp/dist/utils";
import { useDispatch } from "react-redux";
import "../css/Trailer.css";

import image from "../images/dark_gunman.png";
import imageWebp from "../images/dark_gunman.webp";
import background from "../images/video_imagen.png";
import backgroundWebp from "../images/video_imagen.webp";

import DegradeButton from "./buttons/DegradeButton";

import { openVideo } from "../features/video"

const Trailer = () => {
    const dispatch = useDispatch();

    return (
        <div className="Trailer">
            <div
                className="video-trailer"
                style={
                    isWebpSupported()
                        ? { backgroundImage: `url(${backgroundWebp})` }
                        : { backgroundImage: `url(${background})` }
                }
            >
                <Image
                    webp={imageWebp}
                    src={image}
                    alt="Dark Gunman"
                    className="trailer-gunman"
                />
                <button
                    onClick={() => {
                        dispatch(
                            openVideo({
                                modal: true,
                                url: "https://www.youtube.com/watch?v=NkWKBcjp5To",
                                type: "common",
                            })
                        );
                    }}
                >
                    <IoPlay />
                </button>
                <h4>
                    Resultado alumno: <span>Miguel Pacheco</span>
                </h4>
            </div>
            <div className="trailer-content">
                <h1>
                    ¿Quieres aprender a crear un modelo en Blender tan solo en
                    15 días?
                </h1>
                <DegradeButton name={"ÚNETE AHORA"} link={true} width={200} />
            </div>
        </div>
    );
};

export default Trailer;
